import { Account } from '@/domain/usecases'
import { QueryClient } from 'react-query'
import { LoaderFunctionArgs, defer } from 'react-router-dom'
import InternalCompanyManagerBaseLoader from './internal-company-manager-base-loader'

export default class InvoiceDetailLoader extends InternalCompanyManagerBaseLoader {
  private static readonly ID_PATH_PARAM_NAME = 'id'

  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient
  ) {
    super(account, queryClient)
  }

  async loader({ params }: LoaderFunctionArgs) {
    const id = params[InvoiceDetailLoader.ID_PATH_PARAM_NAME] ?? ''

    return defer({
      data: import('../../../factories/usecases/')
        .then(async module => {
          return module.makeRemoteInvoiceEventDetail
        })
        .then(async makeRemoteInvoiceEventDetail => {
          const remoteInvoiceEventDetail = makeRemoteInvoiceEventDetail()
          return {
            invoice: await remoteInvoiceEventDetail.get(id)
          }
        })
    })
  }
}
